import { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'
import { useContext, useEffect } from 'react'
import { LoaderContext } from './LoaderProvider'

export function useQueryWithLoader<TQueryFnData = unknown, TError = unknown, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey>(
    key: string,
    queryKey: TQueryKey,
    queryFn: QueryFunction<TQueryFnData, TQueryKey>,
    options?: Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn' | 'initialData'> & { initialData?: () => undefined }
): UseQueryResult<TData, TError> {
    const queryResult = useQuery({ queryKey, queryFn, ...options })
    const { showLoader, removeLoader } = useContext(LoaderContext)

    useEffect(() => {
        // https://github.com/TanStack/query/issues/3584
        if (options && options.enabled === false) {
            return
        }

        if (queryResult.isPending) {
            showLoader(key)
        } else {
            removeLoader(key)
        }

        return () => {
            removeLoader(key)
        }
    }, [queryResult.isPending])

    return queryResult
}
